module.exports = __webpack_public_path__ + "static/media/0110_LA_BERGERIE_AVEC.7b6d67bd.png";